import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Notification } from './notification.model';
import { Page } from '../../models/page-wrapper.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private apiUrl = `${environment.restApiUrl}notifications`;

  constructor(private http: HttpClient) { }

  /**
   * Retrieves a paginated list of notifications for the current user.
   * The backend should handle user context based on the authenticated session.
   * @param params HttpParams for pagination, sorting, and filtering.
   * @returns An Observable of a paginated list of notifications.
   */
  getNotifications(params: HttpParams): Observable<Page<Notification>> {
    return this.http.get<Page<Notification>>(this.apiUrl, { params });
  }

  /**
   * Marks a single notification as read.
   * @param notificationId The ID of the notification to mark as read.
   * @returns An Observable of the updated notification.
   */
  markAsRead(notificationId: number): Observable<Notification> {
    return this.http.put<Notification>(`${this.apiUrl}/${notificationId}/read`, {});
  }

  /**
   * Marks all unread notifications as read for the current user.
   * @returns An Observable, typically with a success message or count.
   */
  markAllAsRead(): Observable<any> {
    return this.http.post(`${this.apiUrl}/read-all`, {});
  }
}
